<template>
  <nav class="nav-bar-desktop">
    <div class="nav-bar-desktop__left">
      <NavLink
        v-for="page of pageLinks.slice(0, pageLinks.length - 2)"
        :key="page"
        class="link"
        :currentPage="currentPage"
        :page="page"
      />
    </div>

    <div class="nav-bar-desktop__right">
      <NavLink
        v-for="page of pageLinks.slice(pageLinks.length - 2)"
        :key="page"
        :currentPage="currentPage"
        :page="page"
      />
    </div>
  </nav>
</template>

<script setup>
import { watch, ref } from "vue";

import NavLink from "./NavLink.vue";

const props = defineProps({
  pageLinks: {
    type: Array,
    default: () => [],
  },
  currentPage: String,
});

// True as long as page animation is going on
const animating = ref(false);
const animatingToLeft = ref(true);

watch(
  () => props.currentPage,
  (prev, current) => {
    animatingToLeft.value =
      props.pageLinks.indexOf(current) > props.pageLinks.indexOf(prev);
    animating.value = true;

    setTimeout(() => {
      animating.value = false;
    }, 2000);
  }
);
</script>

<style lang="scss" scoped>
.nav-bar-desktop {
  --overlay-size: #{toRem(30)};

  z-index: 5;
  display: flex;
  justify-content: space-between;
  border-block: 1px solid var(--nav-border-color, var(--data-viz-axis-light));
  padding: 0 1.8vw;

  &__left,
  &__right {
    display: flex;
    gap: 1.81rem;
  }

  &__left {
    .link {
      &:first-child {
        border-right: 1px solid
          var(--nav-border-color, var(--data-viz-axis-light));
        padding-right: 1.81rem;
      }
    }
  }
}
</style>
